import { environment } from "src/environments/environment";

export const BASE_FLYSHARE_LINK = `${environment.FRONT_END_URL}/share`;